import { render, staticRenderFns } from "./DownLoading.vue?vue&type=template&id=6fe1b3eb&scoped=true&"
import script from "./DownLoading.vue?vue&type=script&lang=js&"
export * from "./DownLoading.vue?vue&type=script&lang=js&"
import style0 from "./DownLoading.vue?vue&type=style&index=0&id=6fe1b3eb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe1b3eb",
  null
  
)

export default component.exports